module.exports = __webpack_public_path__ + "img/option-background-color.fbe60b13.svg";